export default __webpack_public_path__ + "static/media/gameOver5.3f3a6ba0.mp3";